import logger from '@atlassian/jira-common-util-logging/src/log.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
import { isClientFetchError } from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import type { TimelineEventsServiceResponseError } from '../types/timeline-event.tsx';

export const handleTimelineNetworkError = (
	error: FetchError | Error,
	loggerLocation: string,
): TimelineEventsServiceResponseError => {
	if (error instanceof FetchError && error.statusCode) {
		logger.safeErrorWithoutCustomerData(
			loggerLocation,
			`Endpoint returned unexpected status code ${error.statusCode}`,
		);
		return { error: 'INTERNAL_ERROR', rawError: error };
	}

	if (isClientFetchError(error)) {
		return { error: 'CLIENT_FETCH_ERROR', rawError: error };
	}

	logger.unsafeErrorWithCustomerData(
		loggerLocation,
		`Endpoint returned unexpected response: ${error.message}`,
	);
	return { error: 'VALIDATION_ERROR', rawError: error };
};
